// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match the app's brand blue (Log In button / .ta-button-primary). */
.session-timeout-dialog .btn-primary {
  --bs-btn-bg: rgba(0, 126, 167, 1);
  --bs-btn-border-color: rgba(0, 126, 167, 1);
  --bs-btn-hover-bg: #006885;
  --bs-btn-hover-border-color: #006885;
  --bs-btn-active-bg: #006885;
  --bs-btn-active-border-color: #006885;
  --bs-btn-focus-shadow-rgb: 0, 126, 167;
}

.session-timeout-dialog .btn-outline-primary {
  --bs-btn-color: rgba(0, 126, 167, 1);
  --bs-btn-border-color: rgba(0, 126, 167, 1);
  --bs-btn-hover-bg: rgba(0, 126, 167, 1);
  --bs-btn-hover-border-color: rgba(0, 126, 167, 1);
  --bs-btn-active-bg: #006885;
  --bs-btn-active-border-color: #006885;
  --bs-btn-focus-shadow-rgb: 0, 126, 167;
}

.session-timeout-countdown {
  font-size: 32px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: center;
  color: rgba(0, 126, 167, 1);
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/sessionTimeoutDialog/sessionTimeoutDialog.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,uCAAuC;EACvC,iDAAiD;EACjD,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB","sourcesContent":["/* Match the app's brand blue (Log In button / .ta-button-primary). */\n.session-timeout-dialog .btn-primary {\n  --bs-btn-bg: rgba(0, 126, 167, 1);\n  --bs-btn-border-color: rgba(0, 126, 167, 1);\n  --bs-btn-hover-bg: #006885;\n  --bs-btn-hover-border-color: #006885;\n  --bs-btn-active-bg: #006885;\n  --bs-btn-active-border-color: #006885;\n  --bs-btn-focus-shadow-rgb: 0, 126, 167;\n}\n\n.session-timeout-dialog .btn-outline-primary {\n  --bs-btn-color: rgba(0, 126, 167, 1);\n  --bs-btn-border-color: rgba(0, 126, 167, 1);\n  --bs-btn-hover-bg: rgba(0, 126, 167, 1);\n  --bs-btn-hover-border-color: rgba(0, 126, 167, 1);\n  --bs-btn-active-bg: #006885;\n  --bs-btn-active-border-color: #006885;\n  --bs-btn-focus-shadow-rgb: 0, 126, 167;\n}\n\n.session-timeout-countdown {\n  font-size: 32px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  text-align: center;\n  color: rgba(0, 126, 167, 1);\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
